export default class UrlHelper {
    constructor() {
        this._urlSearchParams = new URLSearchParams(window.location.search.substring(1));
    }

    filterSearchParams() {
        const urlParams = {};

        if (window.jsModuleSettings.storeUrlParams) {
            let filterParams = [];
            if (window.jsModuleSettings.storeUrlParams !== 'true') {
                filterParams = window.jsModuleSettings.storeUrlParams.toLowerCase().split(',');
            }

            this._urlSearchParams.forEach(function (value, key) {
                if (key && (filterParams.length === 0 || filterParams.indexOf(key) > -1)) {
                    urlParams[key] = value;
                }
            });
        }

        return urlParams;
    }

    getParameter(key) {
        return this._urlSearchParams.get(key);
    }

    getUrlSearchParams() {
        return this._urlSearchParams;
    }

    replaceUrlParam(url, key, value) {
        if (url != null)
            url = url.replace('{' + key + '}', encodeURIComponent(value));

        return url;
    }
}